import { Routes, Route } from 'react-router-dom';
import CoursePrograms from './list';
import AddCourseProgram from './add';
import EditCourseProgram from './edit';
import ViewCourseProgram from './view';
import CourseRoutes from './courses';
import EduStandardRoutes from './edu-standards';

const CourseProgramsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<CoursePrograms />} />
      <Route path="/courses/*" element={<CourseRoutes />} />
      <Route path="/edu-standards/*" element={<EduStandardRoutes />} />

      <Route path="/add" element={<AddCourseProgram />} />
      <Route path="/edit/:id" element={<EditCourseProgram />} />
      <Route path="/view/:id" element={<ViewCourseProgram />} />
    </Routes>
  );
};

export default CourseProgramsRoutes;
